module.exports = __webpack_public_path__ + "img/img_sala.68edb063.jpg";